<template>
  <div id="app" class="db">
    <el-container class="db-container" v-if="!$route.meta.hidden">
      <el-aside class="db-menu-wrapper" width="220px">
        <div style="width: 100%; display: flex; justify-content: center">
          <img src="./assets/v2_pz5dcm.png" style="width: 78px; height: 89px; margin: 23px auto" alt="logo"/>
        </div>

        <el-menu :default-active="activeMenu" class="db-menu-bar" router unique-opened background-color="#2F404F"
                 text-color="#ffffff" active-text-color="#ffed2b">
          <div v-for="(route , index) in $router.options.routes[$router.options.routes.length - 1].children"
               :key="index" v-if="access(route.meta.role)">
            <el-submenu :index="route.name" v-if="route.children">
              <template slot="title">
                <icon :name="route.iconClass"></icon>
                <span>{{$t(route.name)}}</span>
              </template>
              <el-menu-item :index="tRoute.name" :route="tRoute" v-for="tRoute in route.children" :key="tRoute.name"
                            v-if="access(tRoute.meta.role)">{{$t(tRoute.name)}}
              </el-menu-item>
            </el-submenu>
            <el-menu-item :index="route.name" :route="route" v-else>
              <icon :name="route.iconClass"></icon>
              <span>{{$t(route.name)}}</span>
            </el-menu-item>
          </div>
        </el-menu>
      </el-aside>

      <el-container class="db-content-wrapper">
        <el-header class="db-header">
          <div class="left-breadcrumb">{{$t($route.name)}}</div>
          <div class="nav-right">
            <span class="nav-right-item welcome">Welcome to Qual Anywhere</span>
            <div class="lang-btn" @click="changeLanguage">
              {{$i18n.locale === "zh" ? "English" : $i18n.locale === "en" ? "中文" : ""}}
            </div>
            <div class="avatar">
              <img :src="getUserInfo.head_image" v-if="getUserInfo.head_image" alt="avatar"/>
              <img src="./assets/lujing.png" v-else alt="avatar"/>
            </div>
            <div class="info">
              <div>{{user ? user.name : ''}}</div>
              <div style="color: #101010">{{user ? user.role_new_str : ''}}</div>
            </div>
            <span class="nav-right-item user-info">
              <span class="logout" @click="logout">
                <icon class="icon" name="sign-out"></icon> Logout
              </span>
            </span>
          </div>
        </el-header>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
    <el-container class='db' v-else>
      <router-view></router-view>
    </el-container>
  </div>
</template>

<script>
  import {getConfigSystemType} from "./api/api";

  export default {
    data() {
      return {
        user: {},
        activeMenu: ""
      };
    },
    created() {
      console.log(this.$route);
      this.activeMenu = this.$route.name || '';
      this.user = JSON.parse(localStorage.getItem("user"));
      getConfigSystemType().then(res => {
        localStorage.setItem("SystemType", JSON.stringify(res.data.data));
      });
      if (!this.user) {
        this.$router.push({
          name: "Login"
        });
      } else {
        this.$store.commit('updateUserInfo', this.user);
        if (this.$route.fullPath === "/feedback/fabric?type=1") {
          if ([4, 7].indexOf(this.user.role_new) > -1) {
            this.$router.replace({
              path: '/feedback/yarn?type=2'
            })
          } else {
            this.$router.replace({
              path: '/feedback/fabric?type=1'
            })
          }
        }
      }
    },

    computed: {
      getUserInfo() {
        return this.$store.state.userInfo;
      }
    },
    watch: {
      $route(to) {
        this.activeMenu = to.name || '';
        this.user = JSON.parse(localStorage.getItem("user"));
        if (this.user) {
          this.$store.commit('updateUserInfo',  this.user);
          if (to.path === "/" || to.path === "/feedback/fabric?type=1") {
            if ([4, 7].indexOf(this.user.role_new) > -1) {
              this.$router.replace({
                path: '/feedback/yarn?type=2'
              })
            } else {
              this.$router.replace({
                path: '/feedback/fabric?type=1'
              })
            }
          }
        } else {
          console.log("aAA");
          /*this.$router.push({
            name: "Login"
          });*/
        }
      }
    },
    methods: {
      // 退出登录
      logout() {
        this.$confirm("Are you sure you want to Logout?", "Prompt", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "info"
        }).then(() => {
          localStorage.removeItem("user");
          this.$router.push({
            name: "Login"
          });
        }).catch(() => {
        });
      },
      // 判断权限
      access(roles) {
        let user = JSON.parse(localStorage.getItem("user"));
        if (user) {
          let role = user.role_new;
          return roles.indexOf(role) >= 0;
        }
      },

      // 切换中英文
      changeLanguage() {
        if (this.$i18n.locale === "en") {
          this.$i18n.locale = "zh";
        } else if (this.$i18n.locale === "zh") {
          this.$i18n.locale = "en";
        }
        localStorage.setItem("lang", this.$i18n.locale);
      },
    },
    mounted() {
    }
  };
</script>

<style lang="scss">
  .el-select-dropdown__wrap {
    max-height: calc(100vh - 200px) !important;
  }
  .el-cascader-menu__wrap{
    max-height: calc(100vh - 200px) !important;
    height: auto;
  }
  .db {
    height: 100%;

    .db-container {
      height: 100%;

      .db-menu-wrapper {
        height: 100%;
        background-color: #2f404f;

        .el-menu {
          border: 1px solid rgb(47, 64, 79);
        }
      }

      .db-content-wrapper {
        min-width: 1000px;

        .db-header {
          background-color: #ffffff;

          .left-breadcrumb {
            font-size: 22px;
            float: left;
            line-height: 60px;
            font-weight: bold;
          }

          .nav-right {
            float: right;
            display: flex;
            align-items: center;
            font-size: 16px;

            .lang-btn {
              width: 100px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              color: #67c23a;
              cursor: pointer;
            }

            .avatar {
              display: flex;
              align-items: center;

              img {
                width: 40px;
                height: 40px;
                margin-right: 10px;
                border-radius: 50%;
                object-fit: cover;
                object-position: center;
              }
            }

            .info {
              margin-right: 27px;
              font-size: 14px;
              color: #101010;
            }

            .nav-right-item {
              line-height: 60px;
              display: block;
              float: left;
              height: 60px;

              &.nav-right-item {
                margin-left: 10px;
              }

              &.welcome {
                margin-right: 0px;
                font-weight: bold;
                font-size: 16px;
              }


            }

            .logout {
              cursor: pointer;

              .fa-icon {
                vertical-align: middle;
              }
            }
          }
        }

        .el-main {
          /*padding: 20px;*/
          border-left: 10px solid #F2f2f2;
          border-top: 10px solid #F2f2f2;
        }
      }
    }
  }

  /*登录模块*/
  .login-header {
    display: flex;
    align-items: center;
    width: calc(100% - 230px);
    height: 60px;
    padding-left: 230px;
    border-bottom: 1px solid #E7E7E7;
    background: #fafafa;

    img {
      width: 40px;
      margin-right: 20px;
    }

    .title {
      font-size: 26px;
      font-family: 'Source Han Sans SC', serif;
      font-weight: bold;
    }
  }

  .login-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 23.3vw;
    padding: 0 80px 20px;
    border: 1px solid #bbbbbb;
    margin: 5vh auto 20px;

    .label {
      display: flex;
      align-items: center;
      width: 100%;
      height: 9.5vh;
      border-bottom: 1px solid #dddddd;
      font-size: 26px;
      color: #101010;
      font-family: 'Source Han Sans SC', serif;
    }

    .input-box {
      min-width: 64.4%;
      margin-top: 5vh;

      .login-btn {
        width: 100%;
        margin-top: 2vh;
      }

      .btn-box {
        display: flex;
        justify-content: space-between;
      }
    }
  }

  .el-table__fixed {
    height:auto !important; // 让固定列的高自适应，且设置!important覆盖ele-ui的默认样式
    bottom:17px; // 固定列默认设置了定位，    position: absolute;top: 0;left: 0;只需要再设置一下bottom的值，让固定列和父元素的底部出现距离即可
  }
</style>



// WEBPACK FOOTER //
// src/App.vue